export const environment = {
  production: false,
  // Added for auth redirect handling
  appBaseUrl: 'http://localhost:8101',
  authRedirects: { verify: '/verificacion' },
  paypal: {
    clientId: 'sb',
    currency: 'EUR',
    intent: 'authorize',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBP_y2tikfEj6gTbdrZJNYSw3OyiUmr3GM',
    authDomain: 'zengado-app.firebaseapp.com',
    databaseURL:
      'https://zengado-app-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'zengado-app',
    storageBucket: 'zengado-app.firebasestorage.app',
    messagingSenderId: '499272550192',
    appId: '1:499272550192:web:f9d2d7f10892024193eaf5',
    measurementId: 'G-574284K2R7',
    vapidKey:
      'BOdUban0bcrRROiAUUz6EqF8rwaKzlNQIA5GT880CPt_JP5SkQqx3k9KBwZt7W_uWuQj0wDHgCGofve_IJHSncw',
    functionsURL: 'https://us-central1-zengado-app.cloudfunctions.net',
  },
  GA_MEASUREMENT_ID: 'G-RD82KEKKY9',
  GTM_CONTAINER_ID: 'GT-NGS7HM6G',
  serverBaseUrl: 'http://localhost:4200/api/',
};
 